import React from 'react';
import './keyboard.css';
import NnPianoKey from './NnPianoKey';
import NnKeyConstants from './NnKeyConstants';
import Note from './Note';

class NnPianoKeyboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.onKeyPress = props.onKeyPress;
    this.state.note = props.nextNote || new Note();
    this.state.activeKey = (this.props.nextNote && this.props.nextNote.name) || '';
    this.renderKey = this.renderKey.bind(this);
    this.isActive = this.isActive.bind(this);
  }

  render() {
    return (
      <div className="KeyboardPanel">
        { NnKeyConstants.keyNames.map(this.renderKey) }
      </div>
    );
  }

  renderKey(keyName) {
    return (
      <NnPianoKey
        active={this.isActive(keyName)}
        black={keyName.length > 1}
        key={keyName}
        note={keyName}
        octave={this.state.note.octave}
        onKeyPress={this.state.onKeyPress}>
      </NnPianoKey>
    )
  }

  isActive(keyName) {
    let note = this.state.note;
    if (note && note.name) {
      return note.name === keyName;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.nextNote && (nextProps.nextNote !== this.state.note)) {
      this.setState({
        note: nextProps.nextNote,
        activeKey: nextProps.nextNote.name
      })
    }
  }
}

export default NnPianoKeyboard;



// WEBPACK FOOTER //
// ./src/NnPianoKeyboard.js